<template>
  <div ref="container">
    <a-modal :title="title" :width="1200" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :columns="columns">
        <template slot="customRenderFlag" slot-scope="status">
          <a-tag v-if="status===0" color="green">启用</a-tag>
          <a-tag v-if="status===2" color="orange">禁用</a-tag>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'VendorModal',
  data() {
    return {
      title: '账号信息',
      visible: false,
      model: {},
      dataSource: [],

      columns: [
        {
          title: '登录名称',
          dataIndex: 'loginName',
          customRender: function (t, r, index) {
            return t
              .replace('（', '')
              .replace('）', '')
              .replace('', '')
              .replace(/[\u0300-\u036f]/g, '')
          },
        },
        {
          title: '经销商名称',
          dataIndex: 'username',
        },
        // {
        //   title: '用户类型',
        //   dataIndex: 'userType',
        // },
        // {
        //   title: '角色',
        //   dataIndex: 'roleName',
        // },
        // {
        //   title: '机构',
        //   dataIndex: 'orgAbr',
        // },
        // {
        //   title: '是否经理',
        //   dataIndex: 'leaderFlagStr',
        // },
        // {
        //   title: '电话号码',
        //   dataIndex: 'phonenum',
        // },
        // {
        //   title: '排序',
        //   dataIndex: 'userBlngOrgaDsplSeq',
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
    }
  },
  created() {},
  methods: {
    add(e) {
      console.log(e, 'e1')
      this.visible = true
      this.dataSource = e
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
</style>